// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import './theme/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import cn from 'element-ui/lib/locale/lang/zh-CN'
import en from 'element-ui/lib/locale/lang/en'
import de from 'element-ui/lib/locale/lang/de'
import es from 'element-ui/lib/locale/lang/es'
import fi from 'element-ui/lib/locale/lang/fi'
import fr from 'element-ui/lib/locale/lang/fr'
import he from 'element-ui/lib/locale/lang/he'
import hu from 'element-ui/lib/locale/lang/hu'
import it from 'element-ui/lib/locale/lang/it'
import ja from 'element-ui/lib/locale/lang/ja'
import ko from 'element-ui/lib/locale/lang/ko'
import nl from 'element-ui/lib/locale/lang/nl'
import vnm from 'element-ui/lib/locale/lang/vi'
import no from 'element-ui/lib/locale/lang/nb-NO'
import th from 'element-ui/lib/locale/lang/th'
import tr from 'element-ui/lib/locale/lang/tr-TR'
import tw from 'element-ui/lib/locale/lang/zh-TW'
import './common.css'
import CommonMethods from '@/CommonMethods.js'
import axios from 'axios'
import VueI18n from 'vue-i18n'
import messages from './language/language.js'
// import 'babel-polyfill'

// alert(router.Router)
Vue.prototype.$http = axios
var lang = localStorage.getItem('language')
// console.log(lang)
var elementLnag
if (lang !== null) {
  switch (lang) {
    case 'cn':
      elementLnag = cn
      break
    case 'en':
      elementLnag = en
      break
    case 'de':
      elementLnag = de
      break
    case 'es':
      elementLnag = es
      break
    case 'fi':
      elementLnag = fi
      break
    case 'fr':
      elementLnag = fr
      break
    case 'he':
      elementLnag = he
      break
    case 'hu':
      elementLnag = hu
      break
    case 'it':
      elementLnag = it
      break
    case 'ja':
      elementLnag = ja
      break
    case 'kr':
      elementLnag = ko
      break
    case 'nl':
      elementLnag = nl
      break
    case 'no':
      elementLnag = no
      break
    case 'th':
      elementLnag = th
      break
    case 'tr':
      elementLnag = tr
      break
    case 'vnm':
      elementLnag = vnm
      break
    case 'tw':
      elementLnag = tw
      break
    default:
      elementLnag = en
  }
} else {
  elementLnag = en
}
Vue.use(VueI18n)
Vue.use(ElementUI, {locale: elementLnag})

Vue.use(CommonMethods)
Vue.config.productionTip = false
const i18n = new VueI18n({
  locale: 'en',
  messages,
  silentTranslationWarn: true
})

if (lang !== null) {
  i18n.locale = lang
}

(async function () {
  // const res = await axios.get('/static/config_dev_demo.json')
  const res = await axios.get('/static/config.json')
  // 基础地址
  console.log(res)
  Vue.prototype.BASE_URL = res.data.BASE_URL
  Vue.prototype.STS_URL = res.data.STS_URL
  Vue.prototype.OSS_URL = res.data.OSS_URL
  Vue.prototype.OSS_BUCKET = res.data.OSS_BUCKET
  Vue.prototype.$Demo = res.data.IS_DEMO
  axios.defaults.baseURL = Vue.prototype.BASE_URL
  Vue.prototype.$store = store
  // 'https://s1.panspy.com'
  axios.defaults.withCredentials = true

  const vueApp = new Vue({
    el: '#app',
    router,
    store,
    i18n,
    components: {App},
    template: '<App/>'
  })
  window.vue = vueApp
  axios.interceptors.request.use(function (config) {
    console.log(config)
    const demoPreRequire = ['Refresh', 'Add', 'Delete', 'Capture', 'SetAlertEmail', 'EnableModule', 'GetOrderLink', 'Unbind', 'WebsiteFilter']
    const currentRequire = config.url.split('/')[config.url.split('/').length - 1]
    console.log(currentRequire)
    if (vueApp.$Demo && demoPreRequire.some(c => c === currentRequire)) {
      vueApp.$confirm(vueApp.$t("Demo account doesn't provide this operation."), {
        showConfirmButton: false,
        cancelButtonText: vueApp.$t('OK'),
        showCancelButton: true,
        customClass: 'message-box-class',
        confirmButtonClass: 'demo-button-primary',
        center: true
      }).then(() => {
      }).catch(() => {
      })
    } else {
      return config
    }
  }, function (error) {
    console.log(error)
  })
  axios.interceptors.response.use(
    response => {
      const res = response.data
      // console.log(res)
      if (res.code === -4) {
        vueApp.$router.push({ path: '/' })
      } else {
        return response
      }
    },
    error => {
      console.log(error)
      if (error && !this.$Demo) {
        vueApp.$router.push({ path: '/' })
      }
    }
  )
})()



// WEBPACK FOOTER //
// ./src/main.js